<template>
    <div>
        <div class="warp-login">
            <div class="login-form nsg-background" :class="{ mobile: isMobile }">
        <div class="has-text-right">
            <LanguageSwitcher />
        </div>
                <div class="logo-container" :class="{ mobile: isMobile }">
               
                </div>
                <LoginForm
                    :loggingIn="loggingIn"
                    :wrongCredentials="wrongCredentials"
                    :helperMessage="helperMessage"
                    @login="callLogin"
                />
            </div>
            <div
                class="login-info"
                v-if="!isMobile"
                style="borderRight: thin solid black"
            >
                <LoginLogo />
            </div>
        </div>
    </div>
   
</template>
 
<script>
import LoginForm from './components/LoginForm';
import LoginLogo from './components/LoginLogo';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
    components: {
        LoginForm,
        LoginLogo,
        LanguageSwitcher
    },
 
    data() {
        return {
            loggingIn: false,
            wrongCredentials: false,
            imgHeight: 0,
            helperMessage: null
        };
    },
 
    computed: {
        ...mapGetters('appStore', ['isMobile'])
    },
 
    created() {
        this.logout();
        window.addEventListener('resize', this.updateImgHeight);
        this.updateImgHeight();
    },
 
    methods: {
        ...mapActions('user', ['setToken', 'setUser', 'setActiveCustomer', 'setActiveCompany', 'logout']),
        ...mapActions('buildingStore', ['setUserBuildingId']),
 
        async callLogin(body) {
            this.wrongCredentials = false;
            this.helperMessage = null;
 
            try {
                const data = await this.$services.user.login(body, {
                    loading: val => {
                        this.loggingIn = val;
                    }
                });
 
                this.setToken(data.token);
                localStorage.setItem('brandexp', JSON.stringify({ token: data.token }));
                this.setUser(data.user);
                this.setActiveCustomer(data.user.customer);
                this.setActiveCompany(data.user.company);
                this.setUserBuildingId(data.user.id);
                localStorage.setItem('brandexp', JSON.stringify({
                  user: data.user,
                  token: data.token,
                  activeCustomer: data.user.customer,
                  activeCompany: data.user.company
                }));
 
                this.$router.push(`/${this.$i18n.locale}/`);
            } catch (error) {
                this.wrongCredentials = true;
 
                if (error.message.includes('No active license'))
                    this.helperMessage = this.$t('login.no_active_license');
            }
        },
 
        updateImgHeight() {
            this.imgHeight = window.innerHeight - window.innerHeight * 0.15;
        }
    },
 
    beforeDestroy() {
        window.removeEventListener('resize', this.updateImgHeight);
    }
};
</script>
 
<style scoped lang="scss">
@import "@/assets/colors.scss";
 
.warp-login {
  width: 100%;
  background: #0d090a;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  flex-direction: row-reverse;
}
.login-form {
  flex: 1;
  min-height: 100vh;
  display: block;
  background-color: $light;
  overflow: hidden;
  position: relative;
  &.mobile {
  }
}
.login-info {
  flex: 2;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;
  text-align: center;
}
.logo-container {
  position: absolute;
  pointer-events: none;
  top: 5rem;
  left: -7rem;
  width: 80%;
  &.mobile {
    width: 100%;
  }
}
.bottom-logo-container {
  width: 50%;
  position: absolute;
  pointer-events: none;
  bottom: 1rem;
  right: 25%;
}
.nsg-background {
    background-image: url('@/assets/nsg.background.png');
    background-size: cover;
    background-position: center;
    background-size: contain unset;
    background-size: auto 65%;
    background-position: top left;
    background-repeat: no-repeat;
    background-color: #0c090a;
}
</style>
